import React from "react"
import NativeSelect from "@material-ui/core/NativeSelect"

export const GenericSelect = ({
  value,
  children,
  id,
  name,
  onChange,
  multiple,
}: {
  value: string | string[]
  children: React.ReactNode
  id: string
  name: string
  onChange: (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => void
  multiple: boolean
}) => {
  return (
    <NativeSelect
      value={value}
      // @ts-ignore
      multiple={multiple}
      onChange={onChange}
      inputProps={{
        name,
        id,
      }}
    >
      {children}
    </NativeSelect>
  )
}
